import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLogoutDark = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		id: "logout",
		children: [/* @__PURE__ */ _jsx("mask", {
			id: "mask0_2500_31397",
			style: { maskType: "alpha" },
			maskUnits: "userSpaceOnUse",
			x: 0,
			y: 0,
			width: 24,
			height: 24,
			children: /* @__PURE__ */ _jsx("rect", {
				id: "Bounding box",
				width: 24,
				height: 24,
				fill: "#D9D9D9"
			})
		}), /* @__PURE__ */ _jsx("g", {
			mask: "url(#mask0_2500_31397)",
			children: /* @__PURE__ */ _jsx("path", {
				id: "logout_2",
				d: "M5.70141 20C5.22596 20 4.82353 19.8353 4.49412 19.5059C4.16471 19.1765 4 18.774 4 18.2986V5.70141C4 5.22596 4.16471 4.82353 4.49412 4.49412C4.82353 4.16471 5.22596 4 5.70141 4H12.0089V5.41176H5.70141C5.62894 5.41176 5.56259 5.44196 5.50235 5.50235C5.44196 5.56259 5.41176 5.62894 5.41176 5.70141V18.2986C5.41176 18.3711 5.44196 18.4374 5.50235 18.4976C5.56259 18.558 5.62894 18.5882 5.70141 18.5882H12.0089V20H5.70141ZM15.9819 16.0181L15.0045 14.9972L17.296 12.7059H9.26706V11.2941H17.296L15.0045 9.00282L15.9819 7.98188L20 12L15.9819 16.0181Z",
				fill: "#162429"
			})
		})]
	})
});
export default SvgLogoutDark;
